
import React, { useState, useEffect } from "react";

import { useSelector, useDispatch } from 'react-redux'
import _, { size } from 'lodash';
import { Bar, Doughnut, Pie, Scatter } from 'react-chartjs-2';
import { Grid, Typography } from "@mui/material";
import { GetColor } from "./RefColorFunctions";
import { GetTransform } from "./RefTransformationFunctions";


const ArcBarHorizontalSingle = (props) => {
    const safeParse = (str)=>{
        try{
            JSON.parse(str)
            return true
        }catch{
            return false;
        }
    }
    const ComponentProperties = props.ComponentProperties
    const { KeyToUse, MaxValue, Label, Color, Proportion, ValueLabels,Transform } = ComponentProperties
    const DataReportData = props.DataReportData
    const ValueArray = DataReportData.map(x=>{return {[KeyToUse]: Transform ? GetTransform(Transform,x[KeyToUse]):x[KeyToUse]}})
    
    const ValueLabelJSON = safeParse(ValueLabels) ? JSON.parse(ValueLabels):{}

    const ArcSumOfValues =
        _.chain(ValueArray)
            .groupBy(KeyToUse)
            .map((value, key) => ({ distribution: key, value: (Proportion ? (value.length / ValueArray.length * 100) : value.length) }))
            .value()

    const BarValues = ArcSumOfValues.map(x=>{return Number(parseFloat((x.value)).toFixed(2))})

    const Labels = ArcSumOfValues.map((s,i)=> {return ((ValueLabelJSON && ValueLabelJSON[s.distribution]) ? ValueLabelJSON[s.distribution] : s.distribution +" (" + (Proportion ? s.value : Number(parseFloat((s.value/ValueArray.length * 100)).toFixed(0))) + "%)") || 'Unknown'})

    const data = {
        labels:[""]
        ,datasets: BarValues.map((bv,i)=> {return {label:Labels[i],data:[Number(bv)],barThickness: 8, backgroundColor: GetColor('RYGG VALUE GRADE', i===0? 1:2)}})
    }

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        indexAxis:'y',
        scales: {
            y: {
                stacked:true,
                max:Proportion ? 100 :ValueArray.length,
                beginAtZero: true,
                grid: {
                    display: false,
                    drawBorder:false
                },
                ticks: {
                    display: true
                }
            }, 
            x: {
                stacked:true,
                max:Proportion ? 100 : ValueArray.length,
                grid: {
                    display: false,
                    drawBorder:false
                },
                ticks: {
                    display: false
                }
            }
        },
        plugins: {
            legend: {
                display: true,
                position:"bottom"
            },
            

        }

    }

    return (
        <Grid container direction="row" alignItems="center" justifyContent={"center"} spacing={2}>
            <Grid item xs={12}>
                <Typography variant="h6" align="center">{Label}</Typography>
            </Grid>
            <Grid item xs={12}>
                 <Bar data={data} options={options}  height={"50px"} width="100%"/>
            </Grid>
        </Grid>
    )
}

export default ArcBarHorizontalSingle